"use strict";

import {onFind} from "../libs/@elements/init-modules-in-scope";
import {findIn} from "../libs/@elements/dom-utils";
import {getConfigValue} from '../libs/@elements/config-utils';
import Pristine from "../libs/pristine/pristine.js";
import {defaultOptions} from "./form-validation";
import {getLoadingContainer} from "./loading-spinner";

const defaultSelectors = {
    base: '.js-form-validation__delivery-guest'
};

let pristineForms = [];

export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        createFormValidation(
            baseElement,
            {...defaultOptions, ...options},
            {...defaultSelectors, ...selectors}
        );
    });
}

export function createFormValidation(form, options = defaultOptions) {

    if (getConfigValue('lang')) {
        Pristine.setLocale(getConfigValue('lang'))
    }
    const pristine = new Pristine(form, options);

    let addressForm = findIn('.js-form-validation__delivery__address', form);
    let alternativeCheckbox = findIn('.js-form-validation__delivery__alternative-input', form);
    let addressType = findIn('#guest_shippingAddressType', form);

    let alternativeBase = findIn('.js-form-validation__delivery__alternative-base', form);
    let alternativePostal = findIn('.js-form-validation__delivery__alternative-postal', form);
    let alternativeStation = findIn('.js-form-validation__delivery__alternative-station', form);

    let addressFormInputs = addressForm.querySelectorAll('input:not([type="hidden"]), select');
    let alternativeBaseInputs = alternativeBase.querySelectorAll('input:not([type="hidden"]), select');
    let alternativePostalInputs = alternativePostal.querySelectorAll('input:not([type="hidden"]), select');
    let alternativeStationInputs = alternativeStation ? alternativeStation.querySelectorAll('input:not([type="hidden"]), select') : null;

    const submitButtonEl = document.getElementsByClassName('js-submit-guest-form__btn');
    window.addEventListener('pagehide', (event) => {
        removeLoadingIndicator(submitButtonEl)
    });

    form.addEventListener('submit', function (e) {
        if(alternativeCheckbox.checked) {
            if(addressType.value === 'postal') {
                if ((pristine.validate(alternativeBaseInputs)) && (pristine.validate(alternativePostalInputs)) && (pristine.validate(addressFormInputs))){
                    addLoadingIndicator(submitButtonEl)
                } else {
                    e.preventDefault();
                }
            }
            if(addressType.value === 'packingStation') {
                if ((pristine.validate(alternativeBaseInputs)) && (pristine.validate(alternativeStationInputs)) && (pristine.validate(addressFormInputs))){
                    addLoadingIndicator(submitButtonEl)
                } else {
                    e.preventDefault();
                }
            }
        } else {
             if (!pristine.validate(addressForm.querySelectorAll('input:not([type="hidden"]), select'))){
                e.preventDefault();
            } else {
                 addLoadingIndicator(submitButtonEl)
             }
        }
    });
    pristineForms.push(pristine);
    return pristine
}

export function updatePristineGuest(form) {
    let pristine = pristineForms.filter((object) => {
        return object.form === form;
    });

    pristine[0].reset(); // resets errors
    pristine[0].destroy(); // clean up

    createFormValidation(form)
}

function addLoadingIndicator(el) {
    for (let i = 0; i < el.length; i++) {
        const button = el[i];
        if (button.style.position !== 'absolute' || 'relative') {
            button.style.position = 'relative';
        }
        button.setAttribute('disabled', true);
        button.innerHTML += getLoadingContainer();
    }
}
function removeLoadingIndicator(el) {
    el.removeAttribute('disabled');
    const loadingContainer = el.getElementsByClassName('loading-overlay')
    if(loadingContainer[0]) {
        el.removeChild(loadingContainer[0])
    }

}
